import React,{ Component } from "react";
import { connect } from "react-redux";
import { createServer } from "../../../actions/actionServer";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import ServerForm from "../ServerForm/ServerForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Servers",path:"/servers",isActive: false},
    {name: "CreateServer",path:"/create_server",isActive: true},
];

class CreateServer extends Component{
    render(){
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Server</strong>
                                </CardHeader>
                                <ServerForm
                                    createServer={this.props.createServer}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

CreateServer.propTypes = {
    createServer: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    servers: state.servers.servers || []
}), 
dispatch => ({
    createServer: (data) => dispatch(createServer(data))
}))(CreateServer);